import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["target"];
import T, { createContext as P, Fragment as m, useContext as s, useEffect as d, useMemo as g, useRef as R, useState as E } from "react";
import { createPortal as C } from "react-dom";
import { useEvent as c } from '../../hooks/use-event.js';
import { useIsoMorphicEffect as y } from '../../hooks/use-iso-morphic-effect.js';
import { useOnUnmount as H } from '../../hooks/use-on-unmount.js';
import { useOwnerDocument as x } from '../../hooks/use-owner.js';
import { useServerHandoffComplete as b } from '../../hooks/use-server-handoff-complete.js';
import { optionalRef as h, useSyncRefs as L } from '../../hooks/use-sync-refs.js';
import { usePortalRoot as O } from '../../internal/portal-force-root.js';
import { env as A } from '../../utils/env.js';
import { forwardRefWithAs as G, render as M } from '../../utils/render.js';
function F(p) {
  var n = O(),
    l = s(_),
    e = x(p),
    _E = E(function () {
      if (!n && l !== null || A.isServer) return null;
      var t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
      if (t) return t;
      if (e === null) return null;
      var r = e.createElement("div");
      return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    }),
    _E2 = _slicedToArray(_E, 2),
    a = _E2[0],
    o = _E2[1];
  return d(function () {
    a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
  }, [a, e]), d(function () {
    n || l !== null && o(l.current);
  }, [l, o, n]), a;
}
var U = m;
function N(p, n) {
  var l = p,
    e = R(null),
    a = L(h(function (u) {
      e.current = u;
    }), n),
    o = x(e),
    t = F(e),
    _E3 = E(function () {
      var u;
      return A.isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }),
    _E4 = _slicedToArray(_E3, 1),
    r = _E4[0],
    i = s(f),
    v = b();
  return y(function () {
    !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
  }, [t, r]), y(function () {
    if (r && i) return i.register(r);
  }, [i, r]), H(function () {
    var u;
    !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
  }), v ? !t || !r ? null : C(M({
    ourProps: {
      ref: a
    },
    theirProps: l,
    defaultTag: U,
    name: "Portal"
  }), r) : null;
}
var S = m,
  _ = P(null);
function j(p, n) {
  var l = p.target,
    e = _objectWithoutProperties(p, _excluded),
    o = {
      ref: L(n)
    };
  return T.createElement(_.Provider, {
    value: l
  }, M({
    ourProps: o,
    theirProps: e,
    defaultTag: S,
    name: "Popover.Group"
  }));
}
var f = P(null);
function ee() {
  var p = s(f),
    n = R([]),
    l = c(function (o) {
      return n.current.push(o), p && p.register(o), function () {
        return e(o);
      };
    }),
    e = c(function (o) {
      var t = n.current.indexOf(o);
      t !== -1 && n.current.splice(t, 1), p && p.unregister(o);
    }),
    a = g(function () {
      return {
        register: l,
        unregister: e,
        portals: n
      };
    }, [l, e, n]);
  return [n, g(function () {
    return function (_ref) {
      var t = _ref.children;
      return T.createElement(f.Provider, {
        value: a
      }, t);
    };
  }, [a])];
}
var D = G(N),
  I = G(j),
  te = Object.assign(D, {
    Group: I
  });
export { te as Portal, ee as useNestedPortals };